import day from 'dayjs'
import { handleApiCall } from '@/utils/handleApiCall'
import { APIService } from '@/api/APIService.js'

export default {
  namespaced: true,
  state: {
    claim: {},
    rawDocuments: [],
    passengerToEdit: null
  },
  actions: {
    async initializeClaim ({ commit }, id) {
      if (!this.state.claim || this.state.claim.Id !== id) {
        await handleApiCall('getClaim', 'claim/INITIALIZE_CLAIM', '', id)
      }
    },
    async refreshClaim ({ commit, state }) {
      return await handleApiCall('getClaim', 'claim/INITIALIZE_CLAIM', '', state.claim.Id)
    },
    async updatePerson ({ getters }, data) {
      const dataObj = getters.getPersonById(data.Id)
      for (const key in data) {
        if (Object.prototype.hasOwnProperty.call(data, key)) {
          const val = data[key]
          if (key.indexOf('LegalRepresentativeLink') === 0 && val) {
            dataObj[key] = {
              LegalRepresentativeLinkType: val.LegalRepresentativeLinkType,
              PersonId: val.PersonId,
              RemarksOther: val.RemarksOther
            }
          } else {
            dataObj[key] = val
          }
        }
      }
      return await handleApiCall('updatePerson', '', '', dataObj)
    },
    async requestPoaHardcopy ({ commit }, data) {
      return await handleApiCall('requestPoaHardcopy', '', '', data)
    },
    async confirmAction ({ commit }, data) {
      return await handleApiCall('confirmAction', '', '', data)
    },
    async sendMessage ({ commit }, data) {
      return await handleApiCall('sendMessage', '', '', data)
    },
    async saveReview ({ commit }, data) {
      if (data.id) {
        return await handleApiCall('updateReview', '', '', data)
      } else {
        return await handleApiCall('createReview', '', '', data)
      }
    },
    async downloadOverview ({ commit }, data) {
      return await handleApiCall('downloadOverview', '', '', data)
    },
    async downloadAttachment ({ commit }, data) {
      return await handleApiCall('downloadAttachment', '', '', data)
    },
    async convertCurrency ({ commit }, data) {
      const result = await handleApiCall('convertCurrency', '', '', data)
      const newResult = parseFloat(result.ConvertCurencyResult).toFixed(2)
      return newResult
    },
    async deleteDocument ({ commit }, formData) {
      return await handleApiCall('deleteDocument', '', '', formData)
    },
    async deleteReceipt ({ commit }, data) {
      return await handleApiCall('deleteReceipt', '', '', data)
    },
    async addPassenger ({ getters }, data) {
      const claim = getters.currentClaim
      data.claimId = claim.Id
      return await handleApiCall('addPassenger', '', '', data)
    },
    // TODO: Replace addNonPassnger with new syntax below !!tricky AF!!
    addNonPassenger ({ commit, getters }, data) {
      data.claimId = getters.claimId
      // temporary fix for missing MiddleName field in NonPassenger table:
      const apiData = { ...data }
      if (apiData.MiddleName) {
        apiData.LastName = `${apiData.MiddleName} ${apiData.LastName}`
      }
      const apiService = new APIService()
      return new Promise((resolve, reject) => {
        apiService.addNonPassenger(apiData).then(result => {
          // Normally we would refresh the claim after adding a (non)passenger.
          // adding a non-passenger is part of adding a minor passenger to the claim
          // refreshing the claim after this submit would interfere with that process
          // That's why the non-passenger is added to the claim with a mutation here
          data.Id = result.data.Id
          commit('ADD_NON_PASSENGER', data)
          resolve(data)
        }, err => { console.log(err) })
      })
    },
    // async addNonPassenger ({ commit, getters }, data) {
    //   data.claimId = getters.claimId
    //   const apiData = { ...data }
    //   if (apiData.MiddleName) {
    //     apiData.LastName = `${apiData.MiddleName} ${apiData.LastName}`
    //   }
    //   return await handleApiCall('addNonPassenger', 'claim/ADD_NON_PASSENGER', '', apiData)
    // },
    async updatePaymentMethod ({ commit }, data) {
      return await handleApiCall('updatePaymentMethod', '', '', data)
    },
    async getRequiredBankAccountFields ({ getters, rootState }, countryCode) {
      const data = { claimId: getters.claimId, countryCode: countryCode || rootState.getCulture.toUpperCase() }
      return await handleApiCall('requiredBankAccountFields', '', '', data)
    },
    async updateBankAccountDetails ({ commit }, data) {
      return await handleApiCall('updateBankAccountDetails', '', '', data)
    },
    async updatePayPalEmail ({ commit }, data) {
      return await handleApiCall('updatePayPalEmail', '', '', data)
    },
    async findAddress ({ commit }, data) {
      return await handleApiCall('findAddress', '', '', data)
    },
    setPassengerToEdit ({ commit }, passengerId) {
      commit('SET_PASSENGER_TO_EDIT', passengerId)
    },
    clearClaim ({ commit }) {
      commit('CLEAR_CLAIM')
    }
  },
  mutations: {
    CLEAR_CLAIM (state) {
      state.claim = {}
    },
    ADD_NON_PASSENGER (state, result) {
      state.claim.NonPassengers.push(result)
    },
    SET_PASSENGER_TO_EDIT (state, passengerId) {
      state.passengerToEdit = passengerId
    },
    INITIALIZE_CLAIM (state, result) {
      const claim = {
        Id: result.Id,
        ReferenceNumber: result.ReferenceNumber,
        SubmittedDate: result.SubmittedDate,
        AirlineCode: result.AirlineCode,
        FlightNumber: result.FlightNumber,
        CanAddPassenger: result.CanAddPassenger,
        DepartureAirport: result.DepartureAirport,
        DepartureFlightDateTime: result.DepartureFlightDateTime,
        ArrivalAirport: result.ArrivalAirport,
        ArrivalFlightDateTime: result.ArrivalFlightDateTime,
        ClaimStatusTitle: result.ClaimStatusTitle,
        ClaimStatus: result.ClaimStatus,
        ClaimClosed: result.ClaimClosed,
        ClaimType: result.ClaimType,
        IncidentType: result.IncidentType,
        IsManagedByClaimManager: result.IsManagedByClaimManager,
        IsPassengerAddressRequired: result.IsPassengerAddressRequired,
        IsPassengerBirthPlaceRequired: result.IsPassengerBirthPlaceRequired,
        CompensationPerPassenger: result.CompensationPerPassenger,
        ParentClaimId: result.ParentClaimId,
        ClaimerPaymentMethod: result.ClaimerPaymentMethod,
        PayPalEMailAccount: result.PayPalEMailAccount,
        TotalClaimValue: result.TotalClaimValue,
        ClientRemarks: result.ClientRemarks,
        CanAddQuote: result.CanAddQuote,
        Passengers: [],
        NonPassengers: [],
        Documents: [],
        Receipts: []
      }

      const bacc = result.BankAccount
      claim.BankAccount = {
        BIC: bacc.BIC,
        BankCity: bacc.BankCity,
        BankName: bacc.BankName,
        Bankleitzahl: bacc.Bankleitzahl,
        CountryCode: bacc.CountryCode,
        Holder: bacc.Holder,
        IBAN: bacc.IBAN,
        Number: bacc.Number,
        Valid: bacc.Valid
      }

      const documents = getAsArray(result.Documents.Document)
      state.rawDocuments = documents

      const rootDocuments = documents.filter(d => !d.ParentDocumentId).map(function (doc) {
        return {
          Id: doc.Id,
          TimeStamp: doc.TimeStamp,
          DocumentAction: doc.DocumentAction,
          CanReact: doc.CanReact,
          ContainsFile: doc.ContainsFile,
          Name: doc.Name,
          Description: doc.Description,
          Message: doc.Message,
          DocumentChecklist: doc.DocumentChecklist,
          ContentType: doc.ContentType,
          DocumentActionArguments: doc.DocumentActionArguments,
          DocumentActionPerformedDateTime: doc.DocumentActionPerformedDateTime,
          IsDocumentActionOptional: doc.IsDocumentActionOptional,
          IsPerformDocumentActionRequired: doc.IsPerformDocumentActionRequired,
          Children: []
        }
      }).sort(function (a, b) { return new Date(b.TimeStamp) - new Date(a.TimeStamp) })

      rootDocuments.forEach(rd => {
        const childdocuments = documents.filter(c => c.ParentDocumentId === rd.Id)
          .map(function (doc) {
            return {
              Id: doc.Id,
              TimeStamp: doc.TimeStamp,
              DocumentAction: doc.DocumentAction,
              CanReact: doc.CanReact,
              ContainsFile: doc.ContainsFile,
              Name: doc.Name,
              Description: doc.Description,
              Message: doc.Message,
              DocumentChecklist: doc.DocumentChecklist,
              ContentType: doc.ContentType
            }
          }).sort(function (a, b) { return new Date(a.TimeStamp) - new Date(b.TimeStamp) })
        rd.Children = childdocuments
      })
      claim.Documents = rootDocuments

      const nonPassengers = getAsArray(result.NonPassengers.Person)
      claim.NonPassengers = nonPassengers.map(p => {
        return {
          Id: p.Id,
          CanModify: p.CanModify,
          CanComplete: p.CanComplete,
          FirstName: p.FirstName,
          MiddleName: p.MiddleName,
          LastName: cleanLastName(p),
          BirthDate: p.BirthDate,
          IsMinor: p.IsMinor,
          BirthPlace: p.BirthPlace,
          City: p.City,
          EMailAddress: p.EMailAddress,
          StreetName: p.StreetName,
          HouseNumber: p.HouseNumber,
          HouseNumberExtension: p.HouseNumberExtension,
          PostalCode: p.PostalCode,
          CountryCode: p.CountryCode,
          Gender: p.Gender,
          IsPassportCheckComplete: p.IsPassportCheckComplete,
          LegalRepresentativeLink1: p.LegalRepresentativeLink1,
          LegalRepresentativeLink2: p.LegalRepresentativeLink2,
          IsBirthPlaceRequired: p.IsBirthPlaceRequired,
          PassportNumber: p.PassportNumber,
          PhoneNumber: p.PhoneNumber,
          TicketNumber: p.TicketNumber
        }
      })
      const passengers = getAsArray(result.Passengers.Person)
      claim.Passengers = passengers.map(p => {
        const passenger = {
          Id: p.Id,
          CanModify: p.CanModify,
          CanComplete: p.CanComplete,
          FirstName: p.FirstName,
          MiddleName: p.MiddleName,
          LastName: cleanLastName(p),
          BirthDate: p.BirthDate,
          IsMinor: p.IsMinor,
          BirthPlace: p.BirthPlace,
          City: p.City,
          EMailAddress: p.EMailAddress,
          StreetName: p.StreetName,
          HouseNumber: p.HouseNumber,
          HouseNumberExtension: p.HouseNumberExtension,
          PostalCode: p.PostalCode,
          CountryCode: p.CountryCode,
          LegalRepresentativeLink1: p.LegalRepresentativeLink1,
          LegalRepresentativeLink2: p.LegalRepresentativeLink2,
          Gender: p.Gender,
          IsPassportCheckComplete: p.IsPassportCheckComplete,
          IsBirthPlaceRequired: p.IsBirthPlaceRequired,
          PassportNumber: p.PassportNumber,
          PhoneNumber: p.PhoneNumber,
          TicketNumber: p.TicketNumber
        }
        return passenger
      })

      const receipts = getAsArray(result.Receipts.Receipt)
      claim.Receipts = receipts.map(r => {
        const file = state.rawDocuments.filter(f => {
          return f.Id === r.DocumentId
        })
        if (file.length === 0) {
          const receipt = {
            Id: r.Id,
            ClaimId: r.ClaimId,
            FileId: '',
            FileName: r.Name,
            FileType: '',
            Description: r.Name,
            Currency: r.Currency,
            Amount: r.Amount,
            AmountInEuros: r.AmountInEuros,
            TransactionDateTime: r.TransactionDateTime
          }
          return receipt
        } else {
          const receipt = {
            Id: r.Id,
            ClaimId: r.ClaimId,
            FileId: file[0].Id,
            FileName: file[0].Name,
            FileType: file[0].ContentType,
            Description: r.Name,
            Currency: r.Currency,
            Amount: r.Amount,
            AmountInEuros: r.AmountInEuros,
            TransactionDateTime: r.TransactionDateTime
          }
          return receipt
        }
      })
      state.claim = claim
    }
  },
  getters: {
    currentClaim: state => state.claim,
    claimId: state => state.claim.Id,
    getClaimDocuments: state => {
      if (state.claim.Documents) {
        const parentDocs = state.claim.Documents.filter(d => !d.ParentDocumentId)
        return parentDocs.map(pd => {
          const children = state.claim.Documents.filter(d => d.ParentDocumentId === pd.Id)
          return {
            children: children.map(c => {
              return { Id: c.Id }
            }),
            Id: pd.Id,
            DocumentAction: pd.DocumentAction
          }
        })
      }
      return []
    },
    isClaimClosed: (state) => {
      return state.claim.ClaimClosed === true
    },
    isEditableByMe: (state, getters, rootState, rootGetters) => {
      const isManaged = rootGetters['dossier/isManagedClaim'](state.claim.Id)
      return (isManaged && state.claim.IsManagedByClaimManager) ||
        (!isManaged && !state.claim.IsManagedByClaimManager)
    },
    isNotEditableMessage: (state, getters, rootState, rootGetters) => {
      const isManaged = rootGetters['dossier/isManagedClaim'](state.claim.Id)
      const errMsg = rootGetters['uistrings/getUiString']
      return isManaged ? errMsg(['lockedMessages', 'lockedForManager']) : errMsg(['lockedMessages', 'lockedForClient'])
    },
    bankAccount: state => state.claim.BankAccount,
    paymentMethod: state => state.claim.ClaimerPaymentMethod,
    paypalAddress: state => state.claim.PayPalEMailAccount,
    getTasks: state => {
      const documents = state.claim.Documents || []
      return documents
        .filter(doc => {
          return doc.DocumentAction && doc.DocumentAction.indexOf('Request') === 0 &&
            doc.IsPerformDocumentActionRequired &&
            !doc.DocumentActionPerformedDateTime
        })
    },
    getClaimEmailAddresses: (state, getters) => {
      return getters.getPersons.map(p => p.EMailAddress.toLowerCase())
    },
    getTaskCount: (state, getters) => getters.getTasks.length,
    getDocumentTask: (state, getters) => id => {
      return getters.getTasks.find(t => t.Id === id)
    },
    getDocumentById: state => id => {
      return state.claim.Documents.find(doc => doc.Id === id)
    },
    getDocumentFilesById: state => id => {
      return state.rawDocuments.filter(d => d.ParentDocumentId === id && d.ContainsFile).sort(function (a, b) { return new Date(a.TimeStamp) - new Date(b.TimeStamp) })
    },
    getReceipts: state => {
      return state.claim.Receipts
    },
    getDocumentFiles: state => {
      return state.rawDocuments.filter(d => d.ContainsFile && (!d.DocumentAction || d.DocumentAction === 'DocumentCustomer'))
    },
    getClaimReview: state => {
      return state.claim.Documents.find(doc => doc.DocumentAction === 'QuoteCustomer') || null
    },
    claimPassengers: state => state.claim.Passengers,
    getPassengerToEdit: state => state.passengerToEdit,
    getPersons: state => {
      const persons = state.claim.Passengers.concat(state.claim.NonPassengers)
      return persons.map(p => {
        return { ...p }
      })
    },
    getLegalPersons: state => {
      const limit = day().subtract(18, 'year')
      const legalPassengers = state.claim.Passengers
        .filter(p => day(p.BirthDate).isBefore(limit))
        .map(p => {
          return {
            LegalRepresentativeLinkType: 'Passenger',
            Name: getFullName(p),
            ...p
          }
        })

      const legalNonPassengers = state.claim.NonPassengers
        .filter(p => day(p.BirthDate).isBefore(limit))
        .map(p => {
          return {
            LegalRepresentativeLinkType: 'NonPassenger',
            Name: getFullName(p),
            ...p
          }
        })

      return legalPassengers.concat(legalNonPassengers)
    },
    getPersonById: state => id => {
      const persons = state.claim.Passengers.concat(state.claim.NonPassengers)
      const person = persons.find(p => p.Id === id)
      if (person) {
        const tussen = person.MiddleName ? person.MiddleName + ' ' : ''
        return { FullName: `${person.FirstName} ${tussen}${person.LastName}`, ...person }
      }
      return null
    },
    getEmptyPerson: () => {
      return {
        CanModify: true,
        CanComplete: true,
        FirstName: '',
        MiddleName: '',
        LastName: '',
        BirthDate: null,
        BirthPlace: '',
        City: '',
        EMailAddress: '',
        StreetName: '',
        HouseNumber: '',
        HouseNumberExtension: '',
        PhoneNumber: '',
        PostalCode: '',
        CountryCode: ''
      }
    },
    getEmptyBankAccount () {
      return {
        BIC: '',
        BankCity: '',
        BankName: '',
        Bankleitzahl: '',
        CountryCode: '',
        Holder: '',
        IBAN: '',
        Number: ''
      }
    },
    getPersonNames: state => {
      const persons = state.claim.Passengers.concat(state.claim.NonPassengers)
      return persons.map(p => {
        const tussen = p.MiddleName ? p.MiddleName + ' ' : ''
        return {
          Id: p.Id,
          Name: `${p.FirstName} ${tussen}${p.LastName}`
        }
      })
    }
  }
}

function getAsArray (objOrArray) {
  if (objOrArray) {
    if (Object.keys(objOrArray).length === 0) {
      return []
    }
  }
  if (objOrArray) {
    return Array.isArray(objOrArray) ? objOrArray : [objOrArray]
  }
  return []
}

function getFullName (person) {
  const middle = person.MiddleName ? `${person.MiddleName} ` : ''
  return `${person.FirstName} ${middle}${person.LastName}`
}

function cleanLastName (person) {
  if (person.MiddleName && person.LastName.indexOf(person.MiddleName) === 0) {
    return person.LastName.substr(person.MiddleName.length).trim()
  }
  return person.LastName
}
